module.exports = __webpack_public_path__ + "img/뱃컨한국형3.779f3203.png";